import { useCallback, useEffect, useState } from 'react'

export function useFullscreen(targetId?: string) {
  const [isFullscreen, setIsFullscreen] = useState(false)

  const toggleFullscreen = useCallback(() => {
    const element = targetId ? document.getElementById(targetId) : document.documentElement
    if (!element) return

    if (document.fullscreenElement) {
      document.exitFullscreen()
    } else {
      element.requestFullscreen()
    }
  }, [targetId])

  useEffect(() => {
    const handleChange = () => {
      const active = !!document.fullscreenElement
      setIsFullscreen(active)
    }

    document.addEventListener('fullscreenchange', handleChange)
    return () => document.removeEventListener('fullscreenchange', handleChange)
  }, [])

  return { isFullscreen, toggleFullscreen }
}
